import React from "react";
import BigMessage from "@/components/BigMessage";
import { useTheme } from "@/components/ThemeProvider";
import classNames from "classnames";
import "./EmptyState.less";

// Default "list empty" message for list pages
export default function EmptyState(props) {
  const { isDarkMode } = useTheme();

  return (
    <div className={classNames("empty-state", { "dark-mode": isDarkMode })}>
      <BigMessage icon="fa-search" message="Sorry, we couldn't find anything." {...props} />
    </div>
  );
}
